function e(t) {
  t.$fastController.renderTemplate(
    t.$fastController.template
  );
}
export {
  e as forceUpdate
};
